import React, { useState } from "react";

const API_URL = 'https://vyprju3478.execute-api.us-west-2.amazonaws.com/dev/contact';

function App() {
    const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
    const [status, setStatus] = useState('');
    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};

        //Name: letters, spaces, hyphens, 2-50 characters
        if (!/^[a-zA-Z\s\-]{2,50}$/.test(form.name)) {
            newErrors.name = 'Name must be 2-50 characters and contain only letters, spaces, or hyphens.';
        }

        //Phone: digits, spaces, dashes, parentheses, 10-15 characters
        if (!/^[\d\s-()]{10,15}$/.test(form.phone)) {
            newErrors.phone = 'Phone number must be 10-15 characters and contain only digits, spaces, dashes, or parentheses.';
        }

        //Email: standard email regex
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
            newErrors.email = 'Invalid email address.';
        }

        // Message: 10-1000 chars, no special characters (XSS prevention)
        const messageRegex = /^[a-zA-Z0-9\s.,!?'"\-\n\r()]+$/;
        if (!messageRegex.test(form.message)) {
            newErrors.message = 'Message contains invalid characters';
        } else if (form.message.length < 10 || form.message.length > 1000) {
            newErrors.message = 'Message must be 10-1000 characters';
        }
    }

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('Sending...');
        try {
            const res = await fetch(API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form)
            });
            if (res.ok) {
                setStatus('Message sent successfully.');
                setForm({ name: '', email: '', message: '' });
            } else {
                setStatus('Error sending message.');
            }
        } catch {
            setStatus('Error sending message.');
        }
    };
    return (
        <div className="textBody">
            <div className="section-box">
                <h1>Insanity Software</h1>
                <hr></hr>
                <p id = 'services'>Software development & IT services for your business.</p>
            </div>

            <div className="section-box">
                <h2>Services</h2>
                <ul>
                    <li>Software Development
                        <ul>
                            <li>Custom Software Development</li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div className="section-box">
                <h3>Contact Us</h3>
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={form.name}
                        onChange={handleChange}
                        required
                    />
                    <input
                        name="phone"
                        placeholder="Phone"
                        value={form.phone}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={form.email}
                        onChange={handleChange}
                        required
                    />
                    <textarea
                        name="message"
                        placeholder="Message"
                        value={form.message}
                        onChange={handleChange}
                        required
                    />
                    <button type="submit">Send</button>
                </form>
            </div>
        </div>
    );
}
export default App;